import { io } from 'socket.io-client'

export const socket = io(process.env.REACT_APP_BACKEND_ADDRESS) //TODO use environment variable
socket.on('connect', () => {
    console.log('connected to server')
})
